"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { ContactBlockComponent } from "@/components/ContactBlock/ContactBlock.builder";
import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const ContactDetailsName = "Footer ContactDetails";

export const ContactDetailsComponent: RegisteredComponent = {
  name: ContactDetailsName,
  models: [getBuilderModelName("footer")],
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  component: dynamic(async () => (await import("./ContactDetails")).ContactDetails),
  inputs: [
    {
      name: "title",
      type: "string",
      defaultValue: "",
    },
    {
      name: "subTitle",
      type: "string",
    },
    {
      name: "text",
      type: "string",
    },
  ],
  childRequirements: {
    message: "Only ContactBlock component are allowed",
    query: {
      "component.name": {
        $in: [ContactBlockComponent.name],
      },
    },
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: ContactBlockComponent.name,
      },
    },
  ],
};
